import { Injectable } from '@angular/core';

import { deslocamentosRoute } from "./data.service";
import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute, detailRoute } from "../../../shared/services/data.service";
import { viagensRoute } from "../../shared/data.service";

@Injectable()
export class DeslocamentoNavigationService {
    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = viagensRoute + '/' + deslocamentosRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = viagensRoute + '/' + deslocamentosRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = viagensRoute + '/' + deslocamentosRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToDetail(objectId: number) {
        let router: string = viagensRoute + '/' + deslocamentosRoute + '/' + detailRoute;
        this._authService.navigateTo(router, objectId);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/shared/deslocamento-navigation.service.ts
 **/